import { withTranslation } from "next-i18next";
import useResponsive from "@helpers/useResponsive";
import Desktop from "./lib/Desktop";
import Mobile from "./lib/Mobile";

const InterestForm: React.FC = () => {
  const isMobile = useResponsive("md");
  const Component = isMobile ? Mobile : Desktop;
  return <Component />;
};

export default withTranslation("common")(InterestForm);
